export default {
  headerGeneral: 'Allgemeine Daten',
  headerSimulationValues: 'Daten zur Teilesimulation',
};
